// Static sample data for the Leadership–Team Alignment view, shaped to mirror the
// future backend payload. `alignmentScore` is the headline overlap % (source of
// truth, computed on raw data); each ranked column carries the skills a group
// flagged as critical, in priority order, with the share (`pct`) that ranked it.
export const ALIGNMENT_SCORE = 31;

// Typical/expected band for the alignment score; scores below it flag a
// leadership-focus conversation.
export const TYPICAL_RANGE = { min: 40, max: 60 };



// The two side-by-side ranked lists.
export const RANKED_COLUMNS = [
    { title: 'Managers Ranked Critical', key: "managersRanked" },
    { title: 'Team Members Ranked Critical', key: "teamMembersRanked" },
];

export const HEADER_TEXT = {
    title: "Leadership team alignment",
    description: "Which skills Managers and Team Members ranked as most critical for success, and how aligned those choices are."
}